/**
 * Analysis Pending Badge Component
 * Shown while analysis is running in the background after the message was delivered.
 * Styled like FeedbackBadge but with muted colors and non-interactive.
 * Morphs into the real FeedbackBadge when analysis completes.
 */

import React from 'react';
import { Box, HStack, Text } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';
import { FS_XS } from '../../theme';
import { useDisplayTheme } from '../../hooks/useDisplayTheme';

export const AnalysisPendingBadge = React.memo(function AnalysisPendingBadge() {
  const { t } = useTranslation();
  const { theme, fontScale, ffs } = useDisplayTheme();

  return (
    <Box
      testID="chat-badge-analysis-pending"
      accessibilityLabel={t('chat.messages.analysisInProgress')}
      accessibilityRole="text"
      style={{ backgroundColor: theme.card, borderColor: theme.border, opacity: 0.6 }}
      borderWidth={1}
      rounded="$full"
      px="$3"
      py="$1"
      alignSelf="flex-end"
    >
      <HStack space="xs" alignItems="center">
        <Text
          allowFontScaling={false}
          style={{
            fontSize: FS_XS * fontScale,
            color: theme.textSecondary,
            fontWeight: '600',
            ...ffs,
          }}
        >
          {t('chat.messages.analyzing')}
        </Text>
      </HStack>
    </Box>
  );
});
